module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "firm_order m0 pr"
  }, [_c('div', {
    staticClass: "firm_order_main pa"
  }, [_c('span', {
    staticClass: "f18"
  }, [_vm._v("页面错误！！")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.errorMessage))])])]), _vm._v(" "), _c('ft')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-73023d35"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/ERROR.vue
// module id = 1167
// module chunks = 41